/**
 * Tutorial guidato delle impostazioni Prodotti.
 *
 * Nessun preparativo: la pagina e' una colonna di riquadri tutti aperti, e il
 * tutorial non tocca ne' gli interruttori ne' i campi - qui si decidono le regole
 * con cui nascono tutti i prodotti nuovi.
 */
const SCOPE = '[data-tour-scope="setting-products"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

export function createProductsSettingsTourSteps() {
	return [
		{
			body: "Questa pagina non contiene prodotti: contiene le regole con cui i prodotti nascono e si comportano. E' una colonna di riquadri, uno per argomento, e conviene percorrerla dall'alto in basso.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'Le regole dei prodotti',
		},
		{
			body: 'Le percentuali di ricarico proposte: quelle che compaiono come scorciatoia quando si calcola il prezzo di vendita partendo dal costo. Sono suggerimenti, non vincoli - il prezzo resta modificabile a mano.',
			key: 'percentage',
			placement: 'top',
			target: at('percentage'),
			title: 'I ricarichi proposti',
		},
		{
			body: "Da cosa si compone l'indirizzo di un prodotto sul sito: il nome c'e' sempre - quello non si toglie - e accanto si puo' aggiungere marca, categoria o codice. Cambiare questa regola non riscrive gli indirizzi dei prodotti gia' pubblicati: vale per quelli nuovi.",
			key: 'slug',
			placement: 'top',
			target: at('slug'),
			title: 'Come si compone l’indirizzo',
		},
		{
			body: 'Le regole con cui il gestionale genera codice prodotto e codice a barre quando non li scrivi tu. Un codice generato male si porta dietro problemi fino ai marketplace, che sui codici sono severi.',
			key: 'sku',
			placement: 'top',
			target: at('sku'),
			title: 'Codici e barcode',
		},
		{
			body: "Cosa fare quando un prodotto finisce: mostrarlo lo stesso come esaurito, nasconderlo, o lasciarlo comprare. E' una scelta commerciale prima che tecnica - un prodotto esaurito ma visibile raccoglie comunque interesse, uno nascosto sparisce anche da Google.",
			key: 'stock',
			placement: 'top',
			target: at('stock'),
			title: 'I prodotti esauriti',
		},
		{
			body: "Gli ultimi due riquadri riguardano il riordino automatico e i prodotti a vendita limitata. Ogni riquadro ha il suo pulsante di conferma: si salva quello su cui si e' lavorato, non tutta la pagina.",
			key: 'riarrange',
			placement: 'top',
			target: at('riarrange'),
			title: 'Riordino e restrizioni',
		},
	];
}
